import { UserType } from 'library/ts/model/user/UserType';
import { EmbedDevice } from 'tag/ts/tag/model/type/embed/EmbedDevice';
import { AbstractSTVPlatformConfig } from 'tag/ts/tag/player/stv/configs/platforms/AbstractSTVPlatformConfig';
export class PlayStation5 extends AbstractSTVPlatformConfig {
    constructor(params, tag) {
        super(params);
        const userType = tag.tagUtilities.getUserType(params?.USER?.userStatus);
        const drmConfigs = userType === UserType.CF ?
            {
                adapter: {
                    options: {
                        config: {
                            drm: {
                                advanced: {
                                    'com.microsoft.playready': {
                                        persistentStateRequired: true,
                                        sessionType: 'persistent-license'
                                    }
                                }
                            }
                        }
                    }
                }
            } : {};
        const baseConfigs = {
            properties: {
                device: EmbedDevice.PS5
            },
            resourceConfig: {
                playback: {
                    abr: {
                        capQualityToScreenSize: false
                    },
                    streaming: {
                        stallEnabled: true,
                        stallSkip: 1.2,
                        stallThreshold: 2,
                        jumpLargeGaps: true
                    },
                    ...drmConfigs
                }
            }
        };
        this.configs = this.utils.DeepMerge.deepmerge(this.configs, baseConfigs);
    }
}
